import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	padding-top: 6px;
	display: flex;
	flex-flow: row wrap;
`;

export const BodyWrapper = styled.div`
	padding-top: 5px;
	display: flex;
	margin-right: auto;
	width: 400px;
`;

export const SelectWrapper = styled.div`
	width: 150px;

	label {
		display: none;
	}

	& span {
		line-height: 24px;
		border-color: ${colors.grey4};
	}
`;

export const Label = styled.div`
	font-size: 11px;
	font-style: normal;
	font-weight: 400;
	line-height: 43px;
	letter-spacing: 0.8px;
	color: ${colors.grey5};
	margin-right: 8px;

	& + div {
		width: 58px;
		margin-right: 16px;

		input {
			min-width: 58px;
			padding-right: 2px;
		}
	}
`;

export const Title = styled.div`
	flex: 0 0 100%;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0.3px;
	text-align: left;
	color: ${colors.grey7};
`;

export const Description = styled.div`
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
	text-align: left;
	color: ${colors.grey5};
	width: 288px;
	margin-right: 57px;
	padding-top: 8px;
`;
